import { render, staticRenderFns } from "./postcardDetail.vue?vue&type=template&id=402095dd&scoped=true"
import script from "./postcardDetail.vue?vue&type=script&lang=js"
export * from "./postcardDetail.vue?vue&type=script&lang=js"
import style0 from "./postcardDetail.vue?vue&type=style&index=0&id=402095dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402095dd",
  null
  
)

export default component.exports